import { ResponseCertificateGeneric } from 'shell/models/response-certificate-generic';
import { HttpResponse } from 'shell/models/http-response';
import { AxiosResponse } from 'axios';

export const transformResponseRequestCertificateGeneric = (
  response: AxiosResponse<HttpResponse<ResponseCertificateGeneric>>
): HttpResponse<ResponseCertificateGeneric> => {
  return response.data;
};
